var hardBreak = function hardBreak() {
  return '\n';
};
export default hardBreak;